import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {CvDto} from 'src/app/services/api-client/models/cv-dto';
import {CvRestControllerService} from 'src/app/services/api-client/services';

@Injectable({
    providedIn: 'root'
})
export class CvByIdResolver implements Resolve<CvDto> {

  constructor(private translate: TranslateService, public cvService: CvRestControllerService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<CvDto> {
    let cvId = parseInt(route.paramMap.get('cvId'));
    this.translate.use(route.data.lang);
    return this.cvService.getCvById({id: cvId});
  }
}
